import { Skeleton } from "@repo/design-system";

export function DetailsPageSkeleton() {
  return (
    <div className="flex min-h-screen flex-col bg-backgroundPrimary p-8 pt-16 md:pt-24">
      <div className="mx-auto w-full max-w-7xl">
        <div className="flex flex-col gap-6">
          <div className="grid grid-cols-[2fr_3fr] gap-6">
            {/* Hero card */}
            <div className="flex flex-col gap-3 rounded-2xl border border-borderPrimary bg-backgroundSecondary p-5">
              <Skeleton className="h-7 w-40 rounded" />
              <Skeleton className="h-6 w-28 rounded" />
              <Skeleton className="h-5 w-full rounded" />
              <Skeleton className="mt-auto h-[240px] w-full rounded-xl" />
            </div>

            {/* Properties + External DBs */}
            <div className="flex flex-col gap-4 rounded-2xl border border-borderPrimary bg-backgroundSecondary p-5">
              <div className="grid grid-cols-2 gap-5">
                {Array.from({ length: 2 }).map((_, col) => (
                  <div key={col} className="flex flex-col gap-3">
                    <Skeleton className="h-6 w-32 rounded" />
                    <div className="overflow-hidden rounded-xl border border-borderPrimary">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <Skeleton
                          key={i}
                          className="h-12 w-full rounded-none border-b border-borderPrimary last:border-b-0"
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Molecule Information */}
          <div className="flex flex-col gap-4 rounded-2xl border border-borderPrimary bg-backgroundSecondary p-5">
            <Skeleton className="h-6 w-48 rounded" />
            <Skeleton className="h-24 w-full rounded-xl" />
          </div>
        </div>
      </div>
    </div>
  );
}
